<template>
  	<v-container fill-height fluid>
    	<v-row>
      		<v-col cols="6" class="pa-0">
        		<AuthSidebar />
      		</v-col>
      		<v-col cols="6" class="pa-0">
                <v-card flat min-height="100%">
                <v-row no-gutters align="center" color="transparent">
						<v-col cols="8" class="text-right">
							Not a member?
							<router-link class="forget primary--text" to="/register"
								>Request access
							</router-link>
						</v-col>
						<v-col cols="3">
							<LanguageSelection class="float-right" />
						</v-col>
					</v-row>
                    <v-stepper v-model="step" class="elevation-0">
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-row class="mt-10" justify="center" align="center">
                                    <v-col cols="7" class="">
                                    <h2 class="text-h5 font-weight-black">Forgot Your Password?</h2>
                                    <p class="body-1">Please enter the email address associated with your account. Password details will be sent to your email address.</p>
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                prepend-inner-icon="mdi-email-outline"
                                                v-model="email"
                                                placeholder="Enter your email"
                                                :error-messages="errors.email"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-row align="center">
                                                <v-divider></v-divider> &nbsp;OR &nbsp; <v-divider></v-divider>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" class="mt-5">
                                            <v-row no-gutters class="d-flex">
                                                <v-col cols="3">
                                                    <v-autocomplete
                                                        style="background-color: #1F5D51;"
                                                        outlined
                                                        :items="countries"
                                                        class="rounded-r-0 outline-l-0 crs-p text-no-wrap"
                                                        item-value="MobileCode"
                                                        v-model="countryCode"
                                                        :filter="filterCountry"
                                                        hide-details
                                                        ref="phoneSelect"
                                                        @change="phoneSelected"
                                                    >
                                                        <template  v-slot:item="slotProps">
                                                            <i :class="[ 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i> &nbsp;
                                                            {{` (+${slotProps.item.MobileCode }) ${slotProps.item.Name}` }}
                                                        </template>
                                                        <div class="truncate" slot="selection" slot-scope="data" style="color:white; font-size:12px; font-weight:bold;">
                                                            <span >
                                                                <!-- <i :class="['em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>&nbsp; -->
                                                                {{`(+${data.item.MobileCode })` }}
                                                            </span>
                                                        </div>
                                                    </v-autocomplete>
                                                </v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        placeholder="Enter your phone number"
                                                        class=""
                                                        outlined
                                                        v-model="mobile"
                                                        :error-messages="errors.mobile"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>   
                                        </v-col>
                                        <v-btn
                                            block
                                            color="primary"
                                            depressed
                                            large
                                            @click="sendOTP"
                                        >Submit</v-btn>
                                    </v-row>
                                    <div class="text-center mt-5">
                                        <router-link style="text-decoration: none;" to="/login">
                                            Back to Log In
                                        </router-link>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-stepper-content>
                        <!--  Old STEP 2 is Removed as per Designs -->
                        <!-- <v-stepper-content step="2">
                            <v-row class="mt-10" justify="center" align="center">
                                <v-col cols="7" class="">
                                <h2>Forgot Your Password?</h2>
                                <p>Please enter the email address associated with your account. Password details will be sent to your email address.</p>
                                <v-row class="mt-5">
                                    <v-radio-group v-model="radioGroup">
                                        <v-radio
                                            :label="`Send a text message to ${'+2*******2983'}`"
                                            :value="1"
                                        ></v-radio>
                                        <v-radio
                                            :label="`Send an email with a link to ${'a*******mail.com'}`"
                                            :value="2"
                                        ></v-radio>
                                    </v-radio-group>
                                    <v-btn
                                            block
                                            class="mt-5"
                                            color="primary"
                                            depressed
                                            large
                                            @click="step=3"
                                        >Continue</v-btn>
                                    </v-row>
                                    <div class="text-center mt-5">
                                        <router-link style="text-decoration: none;" to="/login">
                                            Back to Log In
                                        </router-link>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-stepper-content> -->
                        <v-stepper-content step="2">
                            <v-row class="mt-10" justify="center" align="center">
                                <v-col cols="7" class="">
                                    <h2 class="text-h5 font-weight-black">OTP Verification</h2>
                                    <p class="body-1">Enter the 6 digits code that you received on your email or mobile number..</p>
                                    
                                    <v-card
                                        class="mb-12 text-center"
                                        flat
                                    >
                                        <v-card-title class="font-weight-bold"></v-card-title>
                                        <v-card-text>
                                            <v-otp-input
                                                v-model="otp"
                                                length="6"
                                                plain
                                            ></v-otp-input>
                                            <p class="body-1 mt-10">Didn't receive OTP? 
                                                <v-btn @click="sendOTP"  color="primary" class="body-1 px-0 pb-1 btn" plain depressed> Resend OTP</v-btn>
                                            .</p>
                                        </v-card-text>
                                        
                                </v-card>
                            </v-col>
                        </v-row>   
                        <v-card>
                            <v-card-actions>
                                <v-btn
                                    color="red"
                                    outlined
                                    @click="$router.push({ name: 'Login'})"
                                    large
                                >
                                CANCEL
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    @click="verifyOTP"
                                    :disabled="!isOTPActive"
                                    large
                                >
                                VERIFY
                                </v-btn>
                            </v-card-actions>
                        </v-card> 
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-row class="mt-10" justify="center" align="center">
                                <v-col cols="7" class="">
                                    <h2 class="text-h5 font-weight-black">Set New Password</h2>
                                    <p class="body-1">Enter new password</p>
                                    <v-row class="mt-5">
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                prepend-inner-icon="mdi-lock-outline"
                                                v-model="newPassword"
                                                placeholder="Enter your New Password"
                                                :rules="[
                                                    v => checkPassword(v,'p') || 'Password should be 8 char long, Uppercase , Loswercase, 1 digit and 1 special character (!@#$%^&*)'
                                                ]"
                                            ></v-text-field>

                                            <v-text-field
                                                outlined
                                                prepend-inner-icon="mdi-lock-outline"
                                                v-model="confirmNewPassword"
                                                placeholder="Confirm Password"
                                                :rules="[
                                                    v => checkPassword(v,'c') || 'Password and confirm password should be same.'
                                                ]"
                                            ></v-text-field>
                                            <v-btn
                                            block
                                            class="mt-5"
                                            color="primary"
                                            depressed
                                            large
                                            @click="createNewPassword"
                                        >Set Password</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-stepper-content>
                        <v-stepper-content
                            step="4"
                        >
                        <v-row class="mt-10" justify="center" align="center">
                            <v-col cols="7" class="">
                                <v-card
                                fill-height
                                elevation="0"
                                flat
                                >	<v-row justify="space-around" class="pt-5">
                                        <v-col cols="4" height="180" class="text-center rounded-circle themeGrey">
                                            <img
                                                src="/img/cc.png"
                                                alt="John"
                                            >
                                            </v-col>
                                    </v-row>
                                    <v-card-title class="px-0">
                                        <div class="text-h6 font-weight-black">Your password is reset successfully</div>
                                    </v-card-title>
                                    <v-card-subtitle class="px-0">
                                        <div class="">You can now use your new password to login into your account.</div>
                                    </v-card-subtitle>
                                    <v-btn 
                                        block 
                                        color="primary" 
                                        to="/login"
                                    >
                                       Login Now
                                    </v-btn>
                                </v-card>
                            </v-col>
                        </v-row>
                            </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
                </v-card>
      		</v-col>
    	</v-row>
  	</v-container>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";

import AuthSidebar from "./AuthSidebar.vue";
import countries from "@/constants/countries.js"
import AuthService from "@/_services/AuthService"
export default {
	components: {
		AuthSidebar,
	},
	computed: {
        isAuthErr() {
			return this.authErr.length > 0;
		},
        isOTPActive () {
            return this.otp.length === 6
        },
	},
	data() {
		return {
            otp: '',
            step: 1,
			countryCode: 1,
        	mobile: "",
			countries,
            email: '',
            newPassword: '',
            confirmNewPassword: '',
            resetPasswordToken: '',
            errors: {
                email: '',
                mobile: '',
            },
            rules: {
                email: [
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
            },
		};
	},
	methods: {
        async verifyOTP() {
            this.startLoading();
            try{
                const data = await AuthService.verifyForgPasswordOTP({
                   token: this.resetPasswordToken,
                   otp: this.otp
                })
                if(data.code == 200 && data.success == true) {
                    this.resetPasswordToken = data.data.token;
                    this.step = 3;
                } else {
                    this.$notify({
                        title: data.message,
                        type: 'error'
                    })
                }
                this.stopLoading();
            }catch(e){
                this.$notify({
                    title: e.response.data.message || 'Something went wrong. Please try after sometime.',
                    type: 'error'
                })
                this.stopLoading();  
            }
        },

        async handleSendOTP(type, rdata) {
            this.startLoading();
                try{
                    const data = await AuthService.sendForgotPasswordOTP(type, rdata)
                    if(data.code == 200 && data.success == true) {
                        this.resetPasswordToken = data.data.token;
                        this.step = 2;
                    } else {
                        this.$notify({
                            title: data.message,
                            type: 'error'
                        })
                    }
                    this.stopLoading();
                }catch(e){
                    this.$notify({
                        title: e.response.data.message || 'Something went wrong. Please try after sometime.',
                        text: 'User should login from mobile app to use this option.',
                        type: 'error'
                    }) 
                    this.stopLoading();  
                }
        },

        sendOTP() {
            if(this.validateEmail(this.email)){
                this.handleSendOTP('email', {
                    email: this.email,
                    app_type: 'deforestation'
                })
            }else if(this.validMobileNumber(this.mobile)) {
                this.handleSendOTP('mobile', {
                    mobile: this.mobile,
                    app_type: 'deforestation'
                })
            } else{
                this.$notify({
                    title: 'Please enter a valid email or phone number.',
                    type: 'error'
                })
            }
        },
        async createNewPassword() {
            if(this.checkPassword(this.confirmNewPassword,'c') && this.checkPassword(this.newPassword,'p')){
                this.startLoading();
            try{
                const data = await AuthService.createNewPassword( this.resetPasswordToken,{
                   password: this.newPassword
                })
                if(data.code == 200 && data.success == true) {
                    this.resetPasswordToken = '';
                    this.step = 4;
                } else {
                    this.$notify({
                        title: data.message,
                        type: 'error'
                    })
                }
                this.stopLoading();
            }catch(e){
                this.$notify({
                    title: e.response.data.message || 'Something went wrong. Please try after sometime.',
                    type: 'error'
                })
                this.stopLoading();  
            }
            }else{
                this.$notify({
                    title:'Password and confirm password should be same.',
                    type: 'error'
                })
            }
        },

        checkPassword(v, type){
			var p = false;
			var c = false;
			var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            p = re.test(this.newPassword);
            c = this.confirmNewPassword == this.newPassword

			if(type == 'p'){
				return p;
			}else if(type == 'c'){
				return c;
			}

		},
		phoneSelected() {
			this.$refs.phoneSelect.blur();
		},
  	},
  	mixins: [loading, generalMixin],
};
</script>

<style scoped lang="scss"></style>
